import en from './en';

export default {
  en
};


// WEBPACK FOOTER //
// ./src/i18n/translations/index.js